import type { Dispatch, SetStateAction } from 'react';
import * as React from 'react';

import { Button } from '@coursera/cds-core';
import { CheckIcon, LinkIcon, WarningFilledIcon } from '@coursera/cds-icons';

import { copyText } from 'bundles/enterprise-ui/utils';

export type Props = {
  textToCopy: string;
  defaultLabel: string;
  successLabel?: string;
  failLabel?: string;
  status: 'default' | 'success' | 'failed';
  setStatus: Dispatch<SetStateAction<'default' | 'success' | 'failed'>>;
};

const CopyTextButton: React.FC<Props> = ({ textToCopy, successLabel, failLabel, defaultLabel, status, setStatus }) => {
  let icon: JSX.Element;
  let label: string;

  if (successLabel !== undefined && status === 'success') {
    icon = <CheckIcon />;
    label = successLabel;
  } else if (failLabel !== undefined && status === 'failed') {
    icon = <WarningFilledIcon />;
    label = failLabel;
  } else {
    icon = <LinkIcon />;
    label = defaultLabel;
  }

  return (
    <Button
      variant="ghost"
      icon={icon}
      iconPosition="before"
      onClick={async () => {
        try {
          await copyText(textToCopy);
          setStatus('success');
        } catch {
          setStatus('failed');
        }
      }}
    >
      {label}
    </Button>
  );
};

export default CopyTextButton;
